import React from 'react'
import { graphql, useLazyLoadQuery } from 'react-relay'

import { useParams, Routes, Route, useNavigate } from 'react-router-dom'

import { GuildEventsPastCard } from './GuildEventsPastCard'

import { GuildEventsPastScreenQuery } from './__generated__/GuildEventsPastScreenQuery.graphql'

export const GuildEventsPastScreen = () => {
  const params = useParams()

  const data = useLazyLoadQuery<GuildEventsPastScreenQuery>(
    graphql`
      query GuildEventsPastScreenQuery($id: String!) {
        nodeBySlugId(id: $id) {
          __typename

          ... on Guild {
            ...GuildEventsPastCard_guild
          }
        }

        ...GuildEventsPastCard_query
      }
    `,
    { id: params.actorId! }
  )

  if (data.nodeBySlugId?.__typename !== 'Guild') {
    return null
  }

  return <GuildEventsPastCard guild={data.nodeBySlugId} query={data} />
}

export default GuildEventsPastScreen
